
export const clientId = process.env.REACT_APP_CLIENT_ID;
export const clientIdKarri = process.env.REACT_APP_CLIENT_ID_KARRI;
export const clientIdLlego = process.env.REACT_APP_CLIENT_ID_LLEGO;
export const clientSecret = process.env.REACT_APP_CLIENT_SECRET;
export const clientSecretKarri = process.env.REACT_APP_CLIENT_SECRET_KARRI;
export const clientSecretLlego = process.env.REACT_APP_CLIENT_SECRET_LLEGO;
export const appName = process.env.REACT_APP_NAME;
export const appUrl = process.env.REACT_APP_URL;
export const urlApiFunctionClientes = process.env.REACT_APP_URL_AF_CLIENTES;
export const urlApiCierre = process.env.REACT_APP_URL_CIERRE;
export const urlApiFunctionPlanning = process.env.REACT_APP_URL_FP;
export const urlApiPrepInfo = process.env.REACT_APP_URL_PREP_INFO;
export const urlApiPy = process.env.REACT_APP_URL_PY;
export const appVersion = process.env.REACT_APP_VERSION;
export const urlMyspreadApi = process.env.REACT_APP_URL_NEW_PY;